function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.545 10.239v3.821h5.445c-.712 2.315-2.647 3.972-5.445 3.972a6.033 6.033 0 110-12.064c1.498 0 2.866.549 3.921 1.453l2.814-2.814A9.969 9.969 0 0012.545 2C7.021 2 2.543 6.477 2.543 12s4.478 10 10.002 10c8.396 0 10.249-7.85 9.426-11.748l-9.426-.013z"
});

function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), _ref);
}

export default "data:image/svg+xml;base64,Cjw/eG1sIHZlcnNpb249IjEuMCI/PjxzdmcgZmlsbD0iY3VycmVudENvbG9yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCI+ICAgIDxwYXRoIGQ9Ik0xMi41NDUsMTAuMjM5djMuODIxaDUuNDQ1Yy0wLjcxMiwyLjMxNS0yLjY0NywzLjk3Mi01LjQ0NSwzLjk3MmMtMy4zMzIsMC02LjAzMy0yLjcwMS02LjAzMy02LjAzMiBzMi43MDEtNi4wMzIsNi4wMzMtNi4wMzJjMS40OTgsMCwyLjg2NiwwLjU0OSwzLjkyMSwxLjQ1M2wyLjgxNC0yLjgxNEMxNy41MDMsMi45ODgsMTUuMTM5LDIsMTIuNTQ1LDIgQzcuMDIxLDIsMi41NDMsNi40NzcsMi41NDMsMTJzNC40NzgsMTAsMTAuMDAyLDEwYzguMzk2LDAsMTAuMjQ5LTcuODUsOS40MjYtMTEuNzQ4TDEyLjU0NSwxMC4yMzl6Ii8+PC9zdmc+";
export { SvgGoogle as ReactComponent };